/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloMarcas from 'Infotrack@Modelos/smartStock/marcas';
import IFiltrosMarcas from 'Infotrack@Modelos/smartStock/marcas/entidades/filtrosMarcas';
import IMarcas from 'Infotrack@Modelos/smartStock/marcas/entidades/marcas';

export default class ControladorModeloMarcas {
    private modeloMarcas: ModeloMarcas;
    constructor() {
        this.modeloMarcas = new ModeloMarcas();
    }

    public consultarMarcas() {
        return this.modeloMarcas.consultarMarcas().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearMarcas(marcas: IMarcas) {
        await this.modeloMarcas.crearMarcas(marcas);
    }

    public async editarMarcas(marcas: IMarcas) {
        await this.modeloMarcas.editarMarcas(marcas);
    }
    public async eliminarMarcas(marcas: IMarcas) {
        await this.modeloMarcas.eliminarMarcas(marcas);
    }

    public validarEntidad(marcas: IMarcas): boolean {
        if (marcas.MarcaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarMarcasPorFiltro(marcas: IFiltrosMarcas) {
       return  (await this.modeloMarcas.consultarListaMarcasPorFiltro(marcas)).data.Entidades;
    }
}
